"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.flatNodeTree = void 0;
/**
 * flat tree(transfer tree structure to one dimension array)
 *
 * @param nodeTree tree type of INode
 */
const flatNodeTree = (nodeTree) => {
    return nodeTree.reduce((prev, item) => {
        var _a;
        const nodeItem = Object.assign(Object.assign({}, item), { errType: null, children: ((_a = item.children) === null || _a === void 0 ? void 0 : _a.map(child => child.nodeId)) || [] });
        prev.push(nodeItem);
        if (Array.isArray(item.children) && item.children.length > 0) {
            prev.push(...(0, exports.flatNodeTree)(item.children));
        }
        return prev;
    }, []);
};
exports.flatNodeTree = flatNodeTree;
//# sourceMappingURL=tree.js.map